import React, { useContext, useEffect } from 'react';

import { network, WidgetProps } from '../config';
import { ManifoldContext } from '../Provider';

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/marketplace-widgets/widgets/listing-widgets#m-listing-interactions
export const Interactions = ({ listingId }: WidgetProps) => {
  const { getListingState } = useContext(ManifoldContext);
  const listing = getListingState(listingId);
  const total = listing?.marketplace.listing?.totalAvailable;

  useEffect(() => {
    const interval = setInterval(() => {
      const mInteractionRanks = document.querySelectorAll(
        '.m-interaction__rank',
      );
      if (mInteractionRanks && mInteractionRanks.length > 0) {
        mInteractionRanks.forEach((interaction, index) => {
          if (total && index + 1 > total) {
            // eslint-disable-next-line no-param-reassign
            interaction.innerHTML =
              '<svg width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.458 13.792h1.084V9H9.458zm.538-6.052a.58.58 0 0 0 .594-.585.58.58 0 0 0-.586-.594.58.58 0 0 0-.594.585.58.58 0 0 0 .586.594m.011 9.843a7.4 7.4 0 0 1-2.947-.592 7.65 7.65 0 0 1-2.42-1.63 7.6 7.6 0 0 1-1.631-2.418 7.4 7.4 0 0 1-.592-2.951q0-1.57.592-2.943a7.644 7.644 0 0 1 4.048-4.04 7.4 7.4 0 0 1 2.951-.592q1.57 0 2.943.592a7.68 7.68 0 0 1 4.04 4.043 7.4 7.4 0 0 1 .592 2.94 7.4 7.4 0 0 1-.592 2.948 7.65 7.65 0 0 1-1.63 2.42 7.7 7.7 0 0 1-2.413 1.631 7.4 7.4 0 0 1-2.94.592" fill="#FF5207"></path></svg>';
          }
          if (total && index + 1 <= total) {
            // eslint-disable-next-line no-param-reassign
            interaction.innerHTML = `#${index + 1}`;
          }
        });
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [total]);

  return (
    <div
      data-emits-identity-verify="true"
      data-id={listingId}
      data-network={network}
      data-widget="m-listing-interactions"
      id="listing"
    />
  );
};
